import { defineStore } from 'pinia';
import { useProjectContextStore } from '@/Stores/Web/projectContextStore';
import { apiClient } from '@/Clients/ApiClient.js';
import CartsService from '@/Services/CartsService';
import InitialState from '@/InitialState';
import { orderPaymentStatuses } from '@/Models';
import { projectUserRelationTypes } from '@/Models';

const cartService = new CartsService(apiClient);

export const useProjectUserContextStore = defineStore('projectUserContext', {
    state: () => ({
        projectUserContext: {
            projectID: null,
            userID: null,
            giftCardBalance: 0,
            backerNumber: null,
            hasOrderWithPaymentAction: false,
            relationType: null,
            hasLockedActiveOrder: false,
            // In case of v1 projectUserState is null
            ...InitialState.projectUserState?.projectUserContext ?? {},
        },
        orderWithPaymentAction: null,
    }),
    actions: {
        async loadOrderProcessingPayment() {
            const projectContextStore = useProjectContextStore();
            if (this.projectUserContext?.hasOrderWithPaymentAction && projectContextStore.isV2) {
                const { data } = await cartService.getOrderWithPaymentAction(projectContextStore.projectContext.projectID);
                if (data) {
                    this.orderWithPaymentAction = data;
                }
            }
        },
    },
    getters: {
        hasPositiveGiftCardBalance: state => {
            return state.giftCardBalance > 0;
        },
        giftCardBalance: state => {
            return state.projectUserContext?.giftCardBalance ?? 0;
        },
        backerNumber: state => {
            return state.projectUserContext?.backerNumber ?? null;
        },
        isInProcessingPaymentMode: state => {
            return state.orderWithPaymentAction?.cart.orderPaymentStatus === orderPaymentStatuses.processingPayment;
        },
        isBacker() {
            return this.projectUserContext.relationType === projectUserRelationTypes.originalBacker;
        },
    },
});